import { ListItemText, ListItemTextProps } from '@mui/material';

const ListItemTextWrapper: React.FC<ListItemTextProps> = (props) => <ListItemText {...props} />;

export default ListItemTextWrapper;
